import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
export const ProductsTab = ({
  data
}) => {
  return <div data-id="element-341">
      <h2 className="text-lg font-medium mb-4" data-id="element-342">Your Products</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8" data-id="element-343">
        {data.products.map((product, index) => <div key={index} className="border border-gray-200 rounded-lg p-4" data-id="element-344">
            <h3 className="font-bold" data-id="element-345">{product.name}</h3>
            <p className="text-gray-600 text-sm mb-2" data-id="element-346">{product.type}</p>
            <div className="flex justify-between items-center" data-id="element-347">
              <span className="text-sm text-green-600 bg-green-50 px-2 py-1 rounded-full" data-id="element-348">
                {product.status}
              </span>
              <button className="text-[#5c5cf5] text-sm flex items-center" data-id="element-349">
                See details <ChevronRightIcon size={16} className="ml-1" data-id="element-350" />
              </button>
            </div>
          </div>)}
      </div>
      <h2 className="text-lg font-medium mb-4" data-id="element-351">Recommended Products</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-352">
        <div className="border border-gray-200 rounded-lg p-4" data-id="element-353">
          <div className="flex justify-between items-start" data-id="element-354">
            <div data-id="element-355">
              <h3 className="font-bold" data-id="element-356">6-Month Certificate</h3>
              <p className="text-gray-700" data-id="element-357">
                Earn 5.55% APY* with a low minimum deposit of $500
              </p>
              <button className="text-[#5c5cf5] text-sm flex items-center mt-2" data-id="element-358">
                Learn more <ChevronRightIcon size={16} className="ml-1" data-id="element-359" />
              </button>
            </div>
            <div className="w-6 h-6 rounded-full border border-gray-300" data-id="element-360"></div>
          </div>
        </div>
        <div className="border border-gray-200 rounded-lg p-4" data-id="element-361">
          <div className="flex justify-between items-start" data-id="element-362">
            <div data-id="element-363">
              <h3 className="font-bold" data-id="element-364">Auto Loan</h3>
              <p className="text-gray-700" data-id="element-365">
                New and used vehicle financing with rates as low as 3.99% APR*
              </p>
              <button className="text-[#5c5cf5] text-sm flex items-center mt-2" data-id="element-366">
                Learn more <ChevronRightIcon size={16} className="ml-1" data-id="element-367" />
              </button>
            </div>
            <div className="w-6 h-6 rounded-full border border-gray-300" data-id="element-368"></div>
          </div>
        </div>
      </div>
      <div className="mt-6" data-id="element-369">
        <button className="bg-[#5c5cf5] text-white py-3 px-6 rounded-full font-medium" data-id="element-370">
          Add a product
        </button>
      </div>
    </div>;
};